import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class PlanningJobOverviewNewComponent implements IController {

  job: any;
  onRouteInfoClick: Function;

  public settings: any;
  public taskColorByPurpose: any;


  /* @ngInject */
  constructor(private tasksConstants, private splitService: SplitService) {
      this.taskColorByPurpose = this.tasksConstants.typesToColor;
  }

  $onInit() {
    this.settings = this.splitService.getSitePackageDetailsSettings();
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningJobOverviewNew', {
    bindings: {
      job: '<',
      onRouteInfoClick: '&'
    },
    template: require('./planning-job-overview-new.html').default,
    controller: PlanningJobOverviewNewComponent
  });
